import { render } from "./FloorsFilter.vue?vue&type=template&id=f28e965e&scoped=true"
import script from "./FloorsFilter.vue?vue&type=script&lang=js"
export * from "./FloorsFilter.vue?vue&type=script&lang=js"

import "./FloorsFilter.vue?vue&type=style&index=0&id=f28e965e&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f28e965e"]])

export default __exports__